module.exports = __webpack_public_path__ + "img/network.0a4b52b4.svg";